import "core-js/modules/es.array.from";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import analytics from "web/script/analytics/analytics";
import baustein from "baustein";
import rothko from "web/script/modules/rothko";
import template from "templates/modules/product_page_suggestions.jinja";
import { addVisibilityWatcher } from "web/script/modules/visibility-watcher";
import url from "web/script/utils/url";
import "web/script/components/tracked-link";
export default baustein.register("product-page-suggestions", {
  template: template,
  defaultOptions: {
    slug: null,
    uid: null
  },
  init: function init() {
    this._removeVisibilityWatchers = [];
  },
  getInitialRenderContext: function getInitialRenderContext() {
    return {
      product_page_suggestions: {
        is_loading: true,
        product_slug: null,
        product_uid: null,
        reason: "",
        suggested_card_rows: []
      }
    };
  },
  onInsert: function onInsert() {
    var _this = this;

    var _this$options = this.options,
        isLoading = _this$options.isLoading,
        slug = _this$options.slug,
        uid = _this$options.uid; // If it's not loading, we don't fetch / render anything

    if (!isLoading) {
      this._handleCardData();

      return;
    }

    rothko.fetch("modules/product_page_suggestions", {
      slug: slug,
      uid: uid
    }).then(function (data) {
      if (!data.cards || !data.cards.length) {
        _this.destroy();

        return;
      }

      _this.setRenderContext({
        product_page_suggestions: data
      });

      _this._handleCardData();
    });
  },
  onRemove: function onRemove() {
    this._removeVisibilityWatchers.forEach(function (removeVisibilityWatcher) {
      removeVisibilityWatcher();
    });
  },
  _handleCardData: function _handleCardData() {
    var _this2 = this;

    // Update URLs with reason query parameter
    Array.from(this.el.querySelectorAll("[data-reason]")).forEach(function (suggestedCard) {
      var parsed = url.parse(suggestedCard.href);
      parsed.searchParams.set("reason", suggestedCard.dataset.reason);
      suggestedCard.href = url.unparse(parsed);
    }); // Send events when a user views the suggested cards

    Array.from(this.el.querySelectorAll("[data-seen-event-label]")).forEach(function (suggestedCard) {
      var removeVisibilityWatcher = addVisibilityWatcher(suggestedCard, function (visible) {
        if (visible) {
          var eventLabel = suggestedCard.dataset.seenEventLabel;
          analytics.event("in_viewport", "product_page_suggestions", "seen_".concat(eventLabel), true);
          removeVisibilityWatcher();
        }
      }, {
        rootMargin: "0px"
      });

      _this2._removeVisibilityWatchers.push(removeVisibilityWatcher);
    });
  }
});